import {
    ContractTree,
    ContractTreeRow,
} from '@thought-river/negotiations-common/dist/api/contractManagement';
import { QueryClient } from '@tanstack/react-query';

export const updateTanStackQueryContractsRow = (
    queryClient: QueryClient,
    rowId: number,
    updatedFields: Record<string, any>
) => {
    queryClient.setQueryData(
        ['contracts'],
        (oldData: ContractTree | undefined) => {
            if (!oldData) {
                return oldData;
            }

            return {
                ...oldData,
                rows: oldData.rows.map((row) => {
                    if (row.id !== rowId) {
                        return row;
                    }

                    return {
                        ...row,
                        ...updatedFields,
                    };
                }),
            };
        }
    );
};

//Delete a contract row in a list of contracts
export const deleteTanStackQueryContractsRow = (
    queryClient: QueryClient,
    rowId: number
) => {
    queryClient.setQueryData(
        ['contracts'],
        (oldData: ContractTree | undefined) => {
            if (!oldData) {
                return oldData;
            }

            // Delete requested row
            let updatedRows = oldData.rows.filter((r) => r.id !== rowId);
            // Find any rows the deleted row was a parent of, and make them top-level
            updatedRows = updatedRows.map((row) => {
                if (row.hierarchy?.[0] !== String(rowId)) {
                    return row;
                }

                return {
                    ...row,
                    hierarchy: row.hierarchy?.slice(1),
                };
            });

            return {
                ...oldData,
                rows: updatedRows,
            };
        }
    );
};

//Add a contract row to a list of contracts
export const addTanStackQueryContractsRow = (
    queryClient: QueryClient,
    newRow: ContractTreeRow
) => {
    queryClient.setQueryData(
        ['contracts'],
        (oldData: ContractTree | undefined) => {
            if (!oldData || oldData.rows.some((row) => row.id === newRow.id)) {
                return oldData;
            }

            return {
                ...oldData,
                rows: [newRow, ...oldData.rows],
            };
        }
    );
};
